exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollWrapper .scroll[data-v-383bc392]{height:30%;overflow-x:hidden}.scrollWrapper .medicalCourseCheckboxes[data-v-383bc392]{border:1px solid #d3d3d3;border-radius:4px;padding:10px}", ""]);

// exports
